/**
 * @generated SignedSource<<dbab996b012df0f566f71a2cab3eca6f>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useBeliefSystemCriteria_query$data = {
  readonly currentUser: {
    readonly beliefSystemCriteria: {
      readonly nodes: ReadonlyArray<{
        readonly beliefSystemId: any;
      } | null | undefined>;
    };
  } | null | undefined;
  readonly " $fragmentType": "useBeliefSystemCriteria_query";
};
export type useBeliefSystemCriteria_query$key = {
  readonly " $data"?: useBeliefSystemCriteria_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"useBeliefSystemCriteria_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useBeliefSystemCriteria_query",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "currentUser",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "orderBy",
              "value": [
                "BELIEF_SYSTEM_BY_BELIEF_SYSTEM_ID__SEQUENCE_ASC"
              ]
            }
          ],
          "concreteType": "BeliefSystemCriterionConnection",
          "kind": "LinkedField",
          "name": "beliefSystemCriteria",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "BeliefSystemCriterion",
              "kind": "LinkedField",
              "name": "nodes",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "beliefSystemId",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "beliefSystemCriteria(orderBy:[\"BELIEF_SYSTEM_BY_BELIEF_SYSTEM_ID__SEQUENCE_ASC\"])"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "b96b5d144a6af74ad33ae4eb5302ee08";

export default node;
